import { Component } from "@angular/core";
import { environment } from "src/environments/environment";
import Swal from "sweetalert2";
import { AuthService } from "./auth.service";
import { PagesService } from "src/app/pages/home/pages.service";

@Component({
    selector: 'app-landing-page',
    templateUrl: './auth-langing-page-component.html',
    providers: [AuthService]
})

export class AuthLandingPage {

    currentUser: any;
    userDetails: any;
    envAccess: any;
    userGroups: any;
    userRoles: any;
    roles: string[];
    url :string;
    password: string;
    versionInfo:any
    constructor(private userShareService: AuthService,private pageService: PagesService) { }

    ngOnInit() {

        this.url = environment.serviceApiUrl;

        this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
        this.userDetails = this.currentUser.userDetails[0]
        this.envAccess = this.currentUser.environmentAccess[0]
        this.userGroups = this.userDetails.userGroups[0]
        this.userRoles = this.userGroups.userRoles
        this.roles = this.userRoles.map(userRole => userRole.roleName)
        this.pageService.getVersionInfo().subscribe((x:any)=>{
            this.versionInfo = x.webVersion
          })
        // const iframe = document.createElement('IFRAME');
        // iframe.id = 'ifr';
        // iframe.style.display =  "none";
        // (<HTMLIFrameElement>iframe).src = environment.serviceApiUrl;
        // document.appendChild(iframe);
        this.postUserData("http://34.124.253.133/",'currentUser');
        // this.postUserData("http://localhost:4201",'currentUser');


     


    }


    postUserData(linkUrl, portal) {
        this.userShareService.postCrossDomainMessage(linkUrl, portal);

    }
    login(){
        if (
            this.password == null || this.password == "" || this.password == undefined
          ) {
            Swal.fire("", "Please Enter the Email address", "warning");
           
          }
        
    }




}